import { render, staticRenderFns } from "./htmlread.vue?vue&type=template&id=0cff2b54&scoped=true&"
import script from "./htmlread.vue?vue&type=script&lang=js&"
export * from "./htmlread.vue?vue&type=script&lang=js&"
import style0 from "./htmlread.vue?vue&type=style&index=0&id=0cff2b54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cff2b54",
  null
  
)

export default component.exports